import { getTxtIdMapperPath } from "../../router/txtIdMapper";
import { apiS, apiS_fileDownload } from "./api-base"
import { getESGReqHeader, queryItemReqBody } from "./tool-service";


export const getCompanyOfferingList = async (reqBody) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1040401'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1040401")}`, method: 'post', data: ReqBody })
}

export const F1040402Before = async (reqBody={}) => {
    let ReqBody = {
        ReqHeader: getESGReqHeader('F1040402'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F1040402",true)}`, method: 'post', data: ReqBody })
}

export const createCompanyOffering= async (formData) => { 
    return await apiS({ url: `/${getTxtIdMapperPath("F1040402")}`, method: 'post', data: formData })
}

export const UpdateCompanyOffering= async (formData) => { 
    return await apiS({ url: `/${getTxtIdMapperPath("F1040403")}`, method: 'post', data: formData })
}

export const getCBAMSubItemsByItemNo = async (itemNo, orderNo, param1="", param1OrderNo="") => {
    let reqBody = queryItemReqBody(itemNo, orderNo, param1, param1OrderNo);
    let ReqBody = {
        ReqHeader: getESGReqHeader('F0000104'),
        ReqBody: reqBody
    }
    return await apiS({ url: `/${getTxtIdMapperPath("F0000104")}`, method: 'post', data: ReqBody })
}